import Vue from "vue";
import api from "@/axios.js";

const state = {
  customers: [],
  singleCustomers: [],
  selectedCustomers: [{ ID: 0, code: "All", name: "All" }],
  selectedCustomer: {},
  whiteListUrl: [
    "billing",
    "ar_payment_payment_received",
    "payment",
    "create-credit-note",
    "invoice-exchange",
    "ar-payment",
    "customer-limit",
    "ar-payment-enhance",
  ],
  customerAllOption: { ID: 0, code: "All", name: "All" },
};

const mutations = {
  setCustomers(state, payload) {
    state.customers = JSON.parse(JSON.stringify(payload));
    console.log("cust", state.customers);
  },
  setSelectedCustomers(state, payload) {
    state.selectedCustomers = JSON.parse(JSON.stringify(payload));
  },
  setSelectedCustomer(state, payload) {
    state.selectedCustomer = JSON.parse(JSON.stringify(payload));
  },
  setSingleCustomers(state, payload) {
    state.singleCustomers = JSON.parse(JSON.stringify(payload));
  },
  resetSelectedCustomers(state) {
    state.selectedCustomers = [state.customerAllOption];
  },
  resetState(state) {
    state.selectedCustomers = [state.customerAllOption];
    state.selectedCustomer = {};
  },
  resetLogOut(state) {
    state.customers = [];
    state.singleCustomers = [];
    state.selectedCustomers = [{ ID: 0, code: "All", name: "All" }];
    state.selectedCustomer = {};
  }
};

const getters = {
  getSelectedCustomersCodes(state) {
    return state.selectedCustomers.map((customer) => customer.code);
  },
  getSelectedCustomerCode(state) {
    return state.selectedCustomer.code;
  },
  getSelectedCutomerIDsCopyPaste(state) {
    let ids = state.selectedCustomers.map(customer => customer.ID);

    // if (state.singleCustomers.some(d => d.ID === 0)) {
    //   return [];
    // }
    if (state.selectedCustomers.length == 1 && state.selectedCustomers[0].ID == 0) {
      return [];
    } else if (state.selectedCustomers.length > 1 && state.selectedCustomers[0].ID == 102) {
      ids = state.singleCustomers.map(customer => customer.ID).filter(id => id !== 0);
    }

    console.log("state.singleCustomers", state.singleCustomers);
    console.log("state.selectedCustomers", state.selectedCustomers);

    return ids;
  },
  getSelectedCutomerIDs(state) {
    console.log("state.selectedCustomers", state.selectedCustomers);
    if (state.selectedCustomers.some((d) => d.ID === 0)) {
      return [];
    }
    return state.selectedCustomers.map((customer) => customer.ID);
  },
  getSelectedCutomerCodes(state) {
    console.log("state.selectedCustomers", state.selectedCustomers);
    if (state.selectedCustomers.some((d) => d.ID === 0)) {
      return [];
    }
    return state.selectedCustomers.map((customer) => customer.Code);
  },
  getSelectedCustomerID(state) {
    return state.selectedCustomer.ID;
  },
  getCustomersLength(state) {
    return state.customers.length;
  },
};

const actions = {
  async getCustomers({ commit }, params) {
    showLoading();
    try {
      const response = await api.get("/api/v1/master/customer/options", {
        params,
      });
      commit("setCustomers", [...response.data, state.customerAllOption]);
      commit("setSingleCustomers", response.data);
      console.log(response.data);
    } catch (error) {
      console.log(error);
      hideLoading();
    } finally {
      hideLoading();
    }
  },
  async getCustomerByCopyPaste({ commit }, params) {
    showLoading();
    try {
      const response = await api.get("/api/v1/master/customer/options", {
        params,
      });
      commit("setCustomers", response.data);
      commit("setSingleCustomers", response.data);
    } catch (error) {
      console.log(error);
      hideLoading();
    } finally {
      hideLoading();
    }
  },
  async getAllCustomers({ commit }, territory_id) {
    showLoading();
    try {
      const response = await api.get("/api/v1/master/customer/options", {
        params: {
          territory_id,
        },
      });
      commit("setCustomers", [state.customerAllOption, ...response.data]);
      commit("setSingleCustomers", response.data);
    } catch (error) {
      console.log(error);
      hideLoading();
    } finally {
      hideLoading();
    }
  },
};

function showLoading() {
  Vue.prototype.$vs.loading();
}

function hideLoading() {
  Vue.prototype.$vs.loading.close();
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
